<div class="gcontainer report-thermal-wrapper">
  <div id="drawer" class="drawer-wrapper" [ngClass]="{ 'drawer-active': drawerActive }">
    <div class="drawer-content">
      <div class="drawer-head">
        <span class="t">Figures</span>
        <button mat-icon-button class="close-button" (click)="closeNav()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="spacer"></div>
      <div class="figure-wrapper">
      </div>
    </div>
  </div>
  <div class="breadcrumb-banner-row">
    <nav aria-label="breadcrumb" class="mt-8">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
          <a class="c-primary" [routerLink]="'/dashboard'" tabindex="0"> Dashboard </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          <a
            class="c-primary"
            [routerLink]="['/report/edit', soilType, projectId]"
            [queryParams]="{ edit: 'true' }"
            tabindex="0">
            Edit Report
            @if (companyName) {
              <span> - {{ companyName }}</span>
            }
            @if (projectName) {
              <span> - {{ projectName }}</span>
            }
            @if (soilType === 'precast') {
              <span> - Pre Cast</span>
            }
            @if (soilType === 'nativesoil') {
              <span> - Native Soil</span>
            }
          </a>
        </li>
      </ol>
    </nav>
    <div class="banner-wrapper">
      @if (!userService.roleCheck(['Accounting'])) {
        <div class="r-r">
          <app-customer-attachments
            [projectId]="projectId"
            [backgroundClass]="'none'"
            [showSuccess]="false"
          style="vertical-align: bottom; margin-right: 16px; margin-bottom: 0px; padding-bottom: 0px;"></app-customer-attachments>
          <button class="c-primary" (click)="openViewSubmissionForm()">
            <img src="assets/icons/File.svg" alt="" />View Submission Form
          </button>
          <button class="c-primary" (click)="openWorksheet()">
            <img src="assets/icons/File.svg" alt="" />View Worksheet
          </button>
          <button class="c-primary" (click)="openNotesDialog()">
            <img src="assets/icons/Comment.svg" alt="" />View Notes
          </button>
        </div>
      }
    </div>
  </div>
  <div class="report-thermal-content-wrapper" [ngClass]="{ 'nav-collapsed': !figureNavOpen }">
    @if (numberOfFigures > 0) {
      <button
        type="button"
        class="figure-nav-toggle"
        (click)="toggleFigureNav()"
        [attr.aria-expanded]="figureNavOpen"
        [attr.aria-label]="figureNavOpen ? 'Hide figures list' : 'Show figures list'">
        <mat-icon>{{ figureNavOpen ? 'chevron_left' : 'chevron_right' }}</mat-icon>
      </button>
    }
    @if (numberOfFigures > 0 && figureNavOpen) {
      <nav class="figure-nav-list" aria-label="Figures">
        <div class="figure-nav-title">Figures</div>
        @for (figure of figures; track figure; let i = $index) {
          <button
            type="button"
            class="figure-nav-item"
            [ngClass]="{ active: i === pageIndex }"
            (click)="goToFigure(i)">
            <span class="fn-label">Figure {{ i + 1 }}</span>
            @for (nativeFigureCurve of figure.nativeFigureCurves; track nativeFigureCurve) {
              <span class="fn-sample">
                {{ nativeFigureCurve.sampleLabel }}
              </span>
            }
          </button>
        }
      </nav>
    }
    <div class="left-t-content-wrapper">
      <div class="thermal-header">
        <div class="head">
          <h1>Thermal Resistivity Report</h1>
        </div>
      </div>
      <div class="points-panel">
        @for (nativeFigureCurve of currentFigure?.nativeFigureCurves; track nativeFigureCurve; let curveIndex = $index) {
          <div
            class="curve-section"
            [style.--curve-color]="getCurveColor(curveIndex)">
            <h4 class="curve-label">
              {{ nativeFigureCurve.sampleLabel }}
            </h4>
            @if (nativeFigureCurve.isShown) {
              <div class="curve-points">
                <div class="point-axis-labels">
                  <span class="axis-label">Moisture</span>
                  <span class="axis-label">TR</span>
                </div>
                @for (curvePoint of nativeFigureCurve.curvePoints; track curvePoint; let i = $index; let first = $first; let last = $last) {
                  @if (i > 0 && canAddPoint(curveIndex)) {
                    <button
                      type="button"
                      class="add-point-between-btn"
                      (click)="addPointBetween(curveIndex, i - 1)"
                      aria-label="Add point between">
                      +
                    </button>
                  }
                  <div class="point-container">
                    <input type="number" [value]="curvePoint.moistureContent" (change)="updatePoint(curveIndex, i, 'x', $event)" [readonly]="first" />
                    <input type="number" [value]="curvePoint.tr" (change)="updatePoint(curveIndex, i, 'y', $event)" />
                    @if (!first && !last) {
                      <button
                        type="button"
                        class="delete-point-btn"
                        (click)="deletePoint(curveIndex, i)"
                        aria-label="Delete point">
                        −
                      </button>
                    }
                  </div>
                }
              </div>
            }
            <div class="prediction-settings">
              <div class="prediction-slider">
                <span class="prediction-slider-label">
                  Radius: {{ nativeFigureCurve.radius }} miles
                </span>
                <mat-slider [min]="minRadius" [max]="maxRadius" [step]="1" discrete color="primary">
                  <input
                    matSliderThumb
                    [value]="nativeFigureCurve.radius "
                    (input)="onRadiusChange(nativeFigureCurve, $event)" />
                  </mat-slider>
                </div>
                <div class="prediction-slider">
                  <span class="prediction-slider-label">
                    Similarity Threshold: {{ nativeFigureCurve.threshold }}
                  </span>
                  <mat-slider [min]="minThreshold" [max]="maxThreshold" [step]="0.01" discrete color="primary">
                    <input
                      matSliderThumb
                      [value]="nativeFigureCurve.threshold"
                      (input)="onThresholdChange(nativeFigureCurve, $event)" />
                    </mat-slider>
                  </div>
                </div>
                <div class="curve-section-actions">
                  <button
                    type="button"
                    class="sample-visibility-toggle"
                    (click)="toggleCurveVisibility(nativeFigureCurve)"
                    [attr.aria-pressed]="!nativeFigureCurve.isShown"
                    [attr.aria-label]="nativeFigureCurve.isShown ? 'Hide curve' : 'Show curve'">
                    <mat-icon>{{ nativeFigureCurve.isShown ? 'visibility' : 'visibility_off' }}</mat-icon>
                    <span>{{ nativeFigureCurve.isShown ? 'Hide' : 'Show' }} curve</span>
                  </button>
                  <button
                    type="button"
                    class="predict-btn"
                    (click)="predict(nativeFigureCurve)">
                    <mat-icon>insights</mat-icon>
                    <span>Predict TRs</span>
                  </button>
                  <button
                    type="button"
                    class="predict-btn"
                    (click)="predictWithoutRadiusAndThreshold(nativeFigureCurve)">
                    <mat-icon>insights</mat-icon>
                    <span>Quick Predict</span>
                  </button>
                  <button
                    type="button"
                    class="sample-visibility-toggle"
                    (click)="togglePredictedCurveVisibility(nativeFigureCurve)"
                    [attr.aria-pressed]="!nativeFigureCurve.showPredictedCurve"
                    [attr.aria-label]="nativeFigureCurve.showPredictedCurve ? 'Hide predicted curve' : 'Show predicted curve'">
                    <mat-icon>{{ nativeFigureCurve.showPredictedCurve ? 'visibility' : 'visibility_off' }}</mat-icon>
                    <span>{{ nativeFigureCurve.showPredictedCurve ? 'Hide predicted' : 'Show predicted' }} curve</span>
                  </button>
                </div>
                @if (nativeFigureCurve.predictionError; as predictionError) {
                  <div class="prediction-error">
                    <mat-icon>error_outline</mat-icon>
                    <span>{{ predictionError }}</span>
                  </div>
                }
                @if (nativeFigureCurve.showPredictedCurve && nativeFigureCurve.recommendation; as recommendation) {
                  <div
                    class="prediction-summary"
                    >
                    @if (recommendation.closest_density !== null) {
                      <div class="prediction-summary-row">
                        <span class="prediction-summary-label">Closest density</span>
                        <span class="prediction-summary-value">{{ recommendation.closest_density }}</span>
                      </div>
                    }
                    @if (recommendation.density_range) {
                      <div class="prediction-summary-row">
                        <span class="prediction-summary-label">Density range</span>
                        <span class="prediction-summary-value">{{ recommendation.density_range }}</span>
                      </div>
                    }
                    @if (recommendation.closest_moisture !== null) {
                      <div class="prediction-summary-row">
                        <span class="prediction-summary-label">Closest moisture</span>
                        <span class="prediction-summary-value">{{ recommendation.closest_moisture }} %</span>
                      </div>
                    }
                    @if (recommendation.radius !== null) {
                      <div class="prediction-summary-row">
                        <span class="prediction-summary-label">Chosen radius</span>
                        <span class="prediction-summary-value">{{ recommendation.radius }} miles</span>
                      </div>
                    }
                    @if (recommendation.threshold !== null) {
                      <div class="prediction-summary-row">
                        <span class="prediction-summary-label">Chosen similarity threshold</span>
                        <span class="prediction-summary-value">{{ recommendation.threshold*100 }} %</span>
                      </div>
                    }
                    @if (recommendation.formatted_descriptions.length) {
                      <div class="prediction-summary-row">
                        <span class="prediction-summary-label">Descriptions</span>
                        <span class="prediction-summary-value">
                          @for (description of recommendation.formatted_descriptions; track description) {
                            <span>{{ description }}</span>
                          }
                        </span>
                      </div>
                    }
                    @if (recommendation.filenames.length) {
                      <div class="prediction-summary-row">
                        <span class="prediction-summary-label">Files ({{ recommendation.filenames.length }})</span>
                        <span class="prediction-summary-value">
                          @for (filename of recommendation.filenames; track filename) {
                            <span>{{ filename }}</span>
                          }
                        </span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="right-t-content-wrapper" [style.width.px]="chartBoxWidthPx">
          <label class="project-location-input">
            <span class="project-location-label">Project Location</span>
            <input type="text" [value]="projectLocation" readonly />
          </label>
          @if (currentFigure; as figure) {
            <div class="scale-inputs">
              <label class="scale-input">
                <span class="scale-label">Max X</span>
                <input
                  type="number"
                  [value]="figure.maxX"
                  [min]="15"
                  [step]="5"
                  (change)="onMaxXChange($event)" />
                </label>
                <label class="scale-input">
                  <span class="scale-label">Max Y</span>
                  <input
                    type="number"
                    [value]="figure.maxY"
                    [min]="isMetricValue ? 1.5 : 150"
                    [step]="isMetricValue ? 0.5 : 50"
                    (change)="onMaxYChange($event)" />
                  </label>
                  <label class="scale-checkbox">
                    <input
                      type="checkbox"
                      [checked]="figure.curveShown"
                      (change)="onCurveShownChange($event)" />
                      <span class="scale-label">Show Curve</span>
                    </label>
                    <button
                      mat-raised-button
                      type="button"
                      class="apply-all-button"
                      (click)="applyScaleToAllFigures()">
                      Apply to all figures
                    </button>
                  </div>
                }
                <div class="canvas-wrapper" [style.width.px]="chartWidthPx" [style.height.px]="chartHeightPx">
                  <canvas baseChart
                    [data]="chartData"
                    [options]="chartOptions"
                    [type]="'line'"
                    [width]="chartWidthPx"
                    [height]="chartHeightPx">
                  </canvas>
                </div>
              </div>
              <div class="clearfix"></div>

            </div>

            <div class="thermal-page-button-wrapper">
              <div class="button-left">
                <button mat-raised-button (click)="prev()" [disabled]="prevDisabled">
                  <mat-icon>navigate_before</mat-icon>
                  PREV
                </button>
                <button mat-raised-button [routerLink]="['/report/edit/nativesoil', projectId]" [queryParams]="{ edit: 'true' }">
                  BACK TO REPORT
                </button>
              </div>
              <div class="button-right">
                <button mat-raised-button (click)="previewGraphs()">PREVIEW GRAPHS</button>
                <button mat-raised-button (click)="openFigureOrderingPopup()">ARRANGE FIGURES</button>
                <button mat-raised-button color="primary" (click)="onSubmit()">SAVE</button>
                <button mat-raised-button class="c-next" (click)="next()" [disabled]="nextDisabled">
                  NEXT<mat-icon>navigate_next</mat-icon>
                </button>
              </div>
              <div class="clearfix"></div>
            </div>

            @if (figureOrderingPopupOpen) {
              <app-figure-ordering-popup
                [figures] ="figures"
                [numberOfFigures]="numberOfFigures"
                [projectID]="projectId"
                (save)="saveFigureOrdering($event)"
                (cancel)="closeFigureOrderingPopup()">
              </app-figure-ordering-popup>
            }
          </div>
